import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirtyLensIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dirty_lens"}/>
}
